import { Form, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { fetchBranchTerms } from "../../../../apis/branch.api";

interface POTermsAndConditionsSelectProps {
  branch_data: any;
  setData: Function;
}

const POTermsAndConditionsSelect = ({
  branch_data,
  setData,
}: POTermsAndConditionsSelectProps) => {
  // const { defaultTC, defaultTCDesc } = props;
  const { Option } = Select;
  const [terms, setTerms] = useState<Array<any>>([]);
  const [selected_term, setSelectedTerm] = useState<any>(null);
  useEffect(() => {
    if (branch_data?.id) {
      fetchBranchTerms(branch_data?.id).then((res) => {
        setTerms(res);
        if (res?.length > 0) {
          let termToUse = res?.find((term: any) => term?.id === 1);
          if (!termToUse) {
            termToUse = res[0];
          }

          setSelectedTerm(termToUse);
        }
      });
    }
  }, [branch_data]);
  // useEffect(() => {
  //   console.log("defaultTC", defaultTC, defaultTCDesc);
  //   if (terms.length > 0 && !defaultTC) {
  //     props.handlePOTermsandConditionsSelect({
  //       id: terms[0]?.id,
  //       terms_and_conditions_description: terms[0]?.description,
  //     });
  //   }
  // }, [defaultTC, defaultTCDesc, terms]);

  const termsOptions = terms?.map((each) => (
    <Option key={each.id} value={each.id}>
      {each?.title}
    </Option>
  ));

  useEffect(() => {
    if (selected_term?.id) {
      setData("terms_and_condition", selected_term?.id);
      setData("terms_and_conditions_description", selected_term?.description);
    }
  }, [selected_term]);

  return (
    <React.Fragment>
      <div className="">
        <h6>Terms and Conditions</h6>
        <Form.Item>
          <Select
            className="w-100"
            // key={defaultTC}
            value={selected_term?.id}
            onChange={(e) => {
              const termSelected = terms?.find((term) => term?.id == e);
              setSelectedTerm(termSelected);
            }}
          >
            {termsOptions}
          </Select>
          <div className="mt-2">
            <Input.TextArea
              autoSize={{
                minRows: 4,
                maxRows: 20,
              }}
              key="description_terms"
              placeholder="Add Terms and Conditions here"
              value={selected_term?.description}
              onChange={(e) => {
                setData("terms_and_conditions_description", e.target.value);
              }}
            />
          </div>
        </Form.Item>
      </div>
    </React.Fragment>
  );
};

export default POTermsAndConditionsSelect;
